import { Provider } from 'react-redux';
import { Router } from 'react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider, QueryClient } from 'react-query';

import history from './app/app-history';
import routes from './app/app-routes';
import store from './app/app-store';

export const queryClient = new QueryClient();

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <Router history={history}>
        {routes}
      </Router>
    </QueryClientProvider>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./index.js